<template>
    <router-view :key="$route.fullPath"/>
</template>

<script>

export default {
  name: 'dash'
}
</script>

<style scoped></style>
